/**
 * @generated SignedSource<<af8706e85b32cf3bdf0b99d629b37b26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarThemeArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersArticleSections" | "helpersCheckIsMorningStudioArticle" | "helpersCheckIsPhotoEssayArticle">;
  readonly " $fragmentType": "helpersAppBarThemeArticle";
};
export type helpersAppBarThemeArticle$key = {
  readonly " $data"?: helpersAppBarThemeArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarThemeArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarThemeArticle"
};

(node as any).hash = "3bcec1a0d043d0fa913343bf12611bc2";

export default node;
